var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel flex" }, [
    _c("div", { staticClass: "ynqy" }, [
      _c("p", [
        _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.qysl))]),
        _vm._v("(个) "),
      ]),
      _c("p", [_vm._v("园内企业")]),
      _c("img", {
        attrs: { src: require("images/index/home/yn.png"), alt: "" },
      }),
    ]),
    _c("div", { staticClass: "navHead flex" }, [
      _c("div", { staticClass: "cube" }, [
        _c("div", { staticClass: "name" }, [_vm._v("国家级龙头企业")]),
        _c("div", [
          _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.gnqy))]),
          _c("span", { staticClass: "unit" }, [_vm._v("（个）")]),
        ]),
      ]),
      _c("div", { staticClass: "cube" }, [
        _c("div", { staticClass: "name" }, [_vm._v("省级龙头企业")]),
        _c("div", [
          _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.njqy))]),
          _c("span", { staticClass: "unit" }, [_vm._v("（个）")]),
        ]),
      ]),
      _c("div", { staticClass: "cube" }, [
        _c("div", { staticClass: "name" }, [_vm._v("市级龙头企业")]),
        _c("div", [
          _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.sjqy))]),
          _c("span", { staticClass: "unit" }, [_vm._v("（个）")]),
        ]),
      ]),
      _c("div", { staticClass: "cube" }, [
        _c("div", { staticClass: "name" }, [_vm._v("其他企业")]),
        _c("div", [
          _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.qtqy))]),
          _c("span", { staticClass: "unit" }, [_vm._v("（个）")]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "devideLine" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }